// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1WQ4V","title":"Images90_title__2dfyE","images":"Images90_images__29vyY"};